<template>
  <v-card class="mb-2">
    <v-card-text>
      <h1 class="host-dashboard-title">Past Events</h1>
      <div v-if="loadingEvents">
        Loading...
      </div>
      <div v-else>
        <!-- MOBILE -->
        <div class="hidden-md-and-up">
          <v-card raised v-for="event in getMyPastEvents" :key="event.uuid">
            <v-card-media :src="event.primary_image.image" height="150px"></v-card-media>
            <v-card-text>
              {{ event.title }} <br>
              {{ eventDateTimeMobile(event) }} <br>
              <p v-if="event.location">{{getAddress(event.location)}}</p>
              <p>Attendees: {{event.attendees.length}}/{{event.max_attendees}}</p>
              <p v-if="event.cancelled" style="color: red;">
                Event cancelled
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="openAttendeesModal(props.item)">View Attendees</v-btn>
            </v-card-actions>
          </v-card>
        </div>
        <!-- DESKTOP -->
        <div class="hidden-sm-and-down">
          <v-data-table
            :headers="headers"
            :items="getMyPastEvents"
            hide-actions
            class="elevation-1"
            item-key="title"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="pa-2"><img :src="props.item.primary_image.image" height="50"></td>
                <td class="host-dashboard-tile-title">{{props.item.title}}</td>
                <td class="host-dashboard-tile-sub-title hidden-xs-only">{{ eventDateTime(props.item) }}</td>
                <td class="host-dashboard-tile-sub-title hidden-xs-only" v-if="props.item.location">{{getAddress(props.item.location)}}</td>
                <td class="host-dashboard-tile-sub-title">
                  {{props.item.attendees.length}}/{{props.item.max_attendees}}<br>
                  <a class="cursor-pointer" @click="openAttendeesModal(props.item)">View</a>
                </td>
                <td v-if="props.item.cancelled" class="host-dashboard-tile-sub-title" style="color: red;">
                  Event Cancelled
                </td>
                <td v-else-if="!props.item.approved" class="host-dashboard-tile-sub-title warning--text">
                  Awaiting Approval
                </td>
                <td v-else-if="props.item.approved" class="host-dashboard-tile-sub-title warning--text">
                  Approved
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="error" icon="warning">
                Sorry, nothing to display here :(
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn class="btn-blue" @click="newEvent">New Event</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios'
import moment from 'moment'
import {getAddressStringFromObject, get12hTimeString} from '~/utils/helper'

export default {
  name: 'host_dashboard_upcoming_events',
  data () {
    return {
      loadingEvents: false,
      myEvents: [],
      headers: [
        {
          text: 'Image',
          sortable: false,
          value: 'image'
        },
        { text: 'Title', sortable: false, value: 'title' },
        { text: 'Date & Time', sortable: false, value: 'date' },
        { text: 'Location', sortable: false, value: 'location' },
        { text: 'Attendees', sortable: false, value: 'attendees' },
        { text: 'Status', sortable: false, value: 'status' }
      ]
    }
  },
  created () {
    this.loadingEvents = true
    axios
      .get('api/v1/event/hosting/')
      .then((response) => {
        this.loadingEvents = false
        this.myEvents = response.data
        console.log(response)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  methods: {
    ...mapActions([
      'setModalOpen',
			'setModalProp',
      'addEventResetState'
    ]),
    newEvent() {
			this.addEventResetState()
			this.$router.push('/host/add/event')
		},
    eventDateTime(event) {
			let date = moment(event.date).format('dddd MMMM Do')
			let timeStart = event.time_start
			let timeEnd = event.time_end
			return (
				date +
				' --- ' +
				get12hTimeString(timeStart) +
				' - ' +
				get12hTimeString(timeEnd)
			)
		},
    eventDateTimeMobile(event) {
			let date = moment(event.date).format('MMM Do')
			let timeStart = event.time_start
			let timeEnd = event.time_end
			return (
				date +
				' ' +
				get12hTimeString(timeStart) +
				'-' +
				get12hTimeString(timeEnd)
			)
		},
    getAddress(location) {
			return getAddressStringFromObject(location)
		},
    openAttendeesModal (event) {
      this.setModalProp({ prop: 'eventModalEvent', value: event })
      this.setModalOpen({ prop: 'eventAttendeesModal', value: true })
    }
  },
  computed: {
    ...mapGetters([
      'getModalProp',
      'getMyEvents',
      'getHost',
			'userIsHost'
    ]),
    getMyPastEvents () {
      return this.myEvents.filter(e => moment().diff(moment(e.date), 'days') > 0)
    }
  }
}
</script>

<style>

</style>
